import type {ReactAction} from '@netx/core/bootstrap';
import {faCheck} from '@fortawesome/pro-solid-svg-icons';
import {DownloadRequestActionLabel} from '../locales';
import {type IDownloadRequest, DownloadRequestReviewStatus} from '../schema';

export const downloadRequestActionApproveAllIcon = faCheck;

export type DownloadRequestActionApproveAllParams = Partial<
	Omit<ReactAction, 'cb'>
> & {
	cb: (downloadRequest: IDownloadRequest) => void;
};

/**
 *
 * @param params
 * @returns Action
 */
export const downloadRequestActionApproveAll = (
	downloadRequest: IDownloadRequest,
	{cb, ...params}: DownloadRequestActionApproveAllParams,
): ReactAction => ({
	name: 'download-request-approve-all',
	cb: () => cb(downloadRequest),
	enableTest: () =>
		downloadRequest.reviewStatus === DownloadRequestReviewStatus.PENDING,
	icon: downloadRequestActionApproveAllIcon,
	label: DownloadRequestActionLabel.APPROVE_ALL,
	...params,
});
